<template>
<div class="chapter">
<div class="inner_page">
<div class="ad">
<p class="center"><a href="https://earlybirdbooks.com/?utm_source=EBBGOAAAAE&amp;utm_campaign=9781504083744" target="_blank">
<img alt="image" src="signup.jpg"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebb.vue?1b505c4b